import {
  AnnotationIcon,
  DatabaseIcon,
  DocumentIcon,
  FingerPrintIcon,
  LightningBoltIcon,
  ScaleIcon,
} from "@heroicons/react/outline";
import { Button } from "../components/ui";
import EasyTrans from "../components/bundel/EasyTrans";
import Gallery from "../components/Gallery";
import PriceCard from "../components/landingpage/PriceCard";
import React from "react";
import UserService from "../services/UserService";
import ccheartlogo from "./../assets/cc/heart.black.png";
import { useNavigate } from "react-router-dom";

const features = [
  {
    name: <EasyTrans>Landingpage.LandingpageFeature1Header</EasyTrans>,
    description: (
      <EasyTrans>Landingpage.LandingpageFeature1HeaderCaption</EasyTrans>
    ),
    icon: FingerPrintIcon,
  },
  {
    name: <EasyTrans>Landingpage.LandingpageFeature2Header</EasyTrans>,
    description: (
      <EasyTrans>Landingpage.LandingpageFeature2HeaderCaption</EasyTrans>
    ),
    icon: ScaleIcon,
  },
  {
    name: <EasyTrans>Landingpage.LandingpageFeature3Header</EasyTrans>,
    description: (
      <EasyTrans>Landingpage.LandingpageFeature3HeaderCaption</EasyTrans>
    ),
    icon: DocumentIcon,
  },
  {
    name: <EasyTrans>Landingpage.LandingpageFeature4Header</EasyTrans>,
    description: (
      <EasyTrans>Landingpage.LandingpageFeature4HeaderCaption</EasyTrans>
    ),
    icon: AnnotationIcon,
  },
  {
    name: <EasyTrans>Landingpage.LandingpageFeature5Header</EasyTrans>,
    description: (
      <EasyTrans>Landingpage.LandingpageFeature5HeaderCaption</EasyTrans>
    ),
    icon: DatabaseIcon,
  },
  {
    name: <EasyTrans>Landingpage.LandingpageFeature6Header</EasyTrans>,
    description: (
      <EasyTrans>Landingpage.LandingpageFeature6HeaderCaption</EasyTrans>
    ),
    icon: LightningBoltIcon,
  },
];

const LandingPage = () => {
  let navigate = useNavigate();
  // Somewhere in your code, e.g. inside a handler:

  //#region Views
  return (
    <div>
      <div className="bg-white">
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid items-center gap-6 py-12 lg:grid-cols-2 lg:gap-12 lg:py-24">
            <main className="text-center lg:text-left">
              <div>
                <h1 className="text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-6xl">
                  <span className="block xl:inline">
                    <EasyTrans>Landingpage.LandingpageHeaderColor1</EasyTrans>
                  </span>{" "}
                  <span className="block text-fairblue-500 xl:inline">
                    <EasyTrans>Landingpage.LandingpageHeaderColor2</EasyTrans>
                  </span>
                </h1>
                <p className="mt-3 text-base text-gray-500 sm:mt-5 sm:text-lg sm:max-w-xl sm:mx-auto md:mt-5 md:text-xl lg:mx-0">
                  <EasyTrans>Landingpage.LandingpageHeaderCaption</EasyTrans>
                </p>
                <div className="mt-5 sm:mt-8 sm:flex sm:justify-center lg:justify-start">
                  <div className="rounded-md shadow">
                    <Button
                      variant="primary"
                      size="lg"
                      fullWidth
                      onClick={() => {
                        if (!UserService.isLoggedIn()) {
                          UserService.doRegister();
                        } else {
                          navigate("/registerwork");
                        }
                      }}
                    >
                      <EasyTrans>Landingpage.LandingpageButton1</EasyTrans>
                    </Button>
                  </div>
                  <div className="mt-3 sm:mt-0 sm:ml-3">
                    <Button
                      variant="secondary"
                      size="lg"
                      fullWidth
                      onClick={() => {
                        window.scrollTo({
                          top: document.getElementById("features").offsetTop,
                          behavior: "smooth",
                        });
                      }}
                    >
                      <EasyTrans>Landingpage.LandingpageButton2</EasyTrans>
                    </Button>
                  </div>
                </div>
              </div>
            </main>

            <div className="relative mt-4 lg:mt-0 lg:h-[30rem]">
              <Gallery></Gallery>
            </div>
          </div>
        </div>
      </div>
      <div id="features" className="border-t border-gray-100 py-16 bg-fairgray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="lg:text-center">
            <h2 className="text-base text-fairblue-500 font-semibold tracking-wide uppercase">
              <EasyTrans>Landingpage.LandingpageFeatures</EasyTrans>
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl">
              <EasyTrans>Landingpage.LandingpageFeaturesHeader</EasyTrans>
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto">
              <EasyTrans>Landingpage.LandingpageFeatureHeaderCaption</EasyTrans>
            </p>
          </div>
          <div className="mt-12">
            <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {features.map((feature) => (
                <div
                  key={feature.name.props.children}
                  className="group rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:border-fairblue-100 hover:shadow-md"
                >
                  <dt className="flex items-center gap-4">
                    <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-fairblue-50 text-fairblue-500 transition group-hover:bg-fairblue-500 group-hover:text-white">
                      <feature.icon className="h-6 w-6" aria-hidden="true" />
                    </div>
                    <p className="text-lg font-semibold text-gray-900">
                      {feature.name}
                    </p>
                  </dt>
                  <dd className="mt-4 text-base text-gray-500">
                    {feature.description}
                  </dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
      <div className="bg-fairdarkgreen">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl sm:tracking-tight">
            <span className="block">
              <EasyTrans>Landingpage.LandingpageTryColor1</EasyTrans>
            </span>
            <span className="block text-white/80">
              <EasyTrans>Landingpage.LandingpageTryColor2</EasyTrans>
            </span>
          </h2>
          <div className="mt-8 flex flex-shrink-0 flex-col gap-3 sm:flex-row lg:mt-0">
            <Button
              variant="cta"
              size="lg"
              onClick={() => UserService.doRegister()}
            >
              <EasyTrans>Landingpage.LandingpageTryButton1</EasyTrans>
            </Button>
            <a href="/searchworks">
              <Button variant="outline" size="lg" fullWidth>
                <EasyTrans>Landingpage.LandingpageTryButton2</EasyTrans>
              </Button>
            </a>
          </div>
        </div>
      </div>
      <div className="bg-white">
        <div className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-4 px-4 py-12 text-center sm:flex-row sm:gap-5">
          <img className="h-16 w-auto sm:h-20" src={ccheartlogo} alt="" />
          <p className="text-lg font-semibold text-gray-700 sm:text-xl">
            <EasyTrans>Landingpage.CCAustria</EasyTrans>
          </p>
        </div>
      </div>
      <div className="border-t border-gray-100 bg-fairgray">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <div className="grid grid-cols-1 items-stretch gap-8 pt-3 lg:grid-cols-3 lg:gap-6">
            <PriceCard
              price="0"
              storage="200 MB"
              nameLangKey="Landingpage.PriceCards.Free.Name"
              onClick={() => {
                navigate("/registerwork");
              }}
            ></PriceCard>
            <PriceCard
              price="36"
              storage="5 GB"
              popular
              nameLangKey="Landingpage.PriceCards.Standard.Name"
              goto="https://shop.fairkom.net/produkt/fairregister-basic/"
            ></PriceCard>
            <PriceCard
              price="144"
              storage="50 GB"
              nameLangKey="Landingpage.PriceCards.Expert.Name"
              goto="https://shop.fairkom.net/produkt/fairregister-pro/"
            ></PriceCard>
          </div>
        </div>
      </div>
    </div>
  );
  //#endregion
};

export default LandingPage;
